import RemoveAttachmentDataProviderResponse from 'owa-service/lib/contract/RemoveAttachmentDataProviderResponse';
import removeAttachmentDataProviderRequest from 'owa-service/lib/factory/removeAttachmentDataProviderRequest';
import removeAttachmentDataProviderOperation from 'owa-service/lib/operation/removeAttachmentDataProviderOperation';

export default function removeFileProvider(
    fileProviderId: string
): Promise<RemoveAttachmentDataProviderResponse> {
    const request = removeAttachmentDataProviderRequest({
        DataProviderId: fileProviderId,
    });

    return removeAttachmentDataProviderOperation(request);
}
